var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"margins__double",attrs:{"padding":"medium","color":"grey"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"sm":"auto"}},[_c('ContractSVG',{staticClass:"icon icon--large"})],1),_c('b-col',[_c('Margins',[_c('h6',{staticClass:"text-normal"},[_vm._v(_vm._s(_vm.$t('YOUR_PLAN')))]),_c('YourPlanList')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }